export function countOrderProductsByType({ order, }) {
    const result = {
        cancelled: 0,
        bundle: 0,
        configurable: 0,
        discount: 0,
        giftCard: 0,
        nonDiscount: 0,
        service: 0,
        total: 0,
        totalAbsolute: 0,
        totalDistinct: 0,
        totalDistinctAbsolute: 0,
    };
    const orderLines = order?.Lines ?? [];
    orderLines.forEach((orderLine) => {
        // We are only interested in product counts
        //
        if (orderLine.Product) {
            if (orderLine.IsCancelled) {
                result.cancelled += 1;
            }
            else {
                result.total += orderLine.TotalQuantityToShip;
                result.totalAbsolute += Math.abs(orderLine.TotalQuantityToShip);
                if (!orderLine.ParentID) {
                    result.totalDistinct += orderLine.TotalQuantityToShip;
                    result.totalDistinctAbsolute += Math.abs(orderLine.TotalQuantityToShip);
                }
                const productType = orderLine.Product.Type;
                const isBundle = (productType & 2048) !== 0;
                const isConfigurable = (productType & 16384) !== 0;
                const isGiftCard = (productType & 8) !== 0;
                const isService = (productType & 16) !== 0;
                if (isBundle) {
                    result.bundle += 1;
                }
                if (isConfigurable) {
                    result.configurable += 1;
                }
                if (isGiftCard) {
                    result.giftCard += 1;
                }
                if (isService) {
                    result.service += 1;
                }
                // Gift products have a special custom order line type
                //
                if (orderLine.CustomOrderLineType === 'DISCOUNTPRODUCT') {
                    result.discount += 1;
                }
            }
        }
    });
    // Add non discount count as a convenience
    //
    result.nonDiscount = result.total - result.discount;
    return result;
}
//# sourceMappingURL=product-count-by-type.js.map